import React from "react";
import styles from "../styles/illustration.module.css";

const Illustration = () => {
  return (
    <div className={styles.illustration}>
      <img src="./images/signup.svg" alt="Signup" />
    </div>
  );
};

export default Illustration;
